// WebAuthn helpers: base64url <-> ArrayBuffer, JSON options -> browser options, credential -> JSON for py_webauthn.
export const isFramed = () => { try { return window.self !== window.top; } catch (_) { return true; } };
export const passkeysSupported = () => typeof window !== "undefined" && !!window.PublicKeyCredential && !!navigator.credentials;

const toBuf = (s) => Uint8Array.from(atob(s.replace(/-/g, "+").replace(/_/g, "/") + "===".slice((s.length + 3) % 4)), (c) => c.charCodeAt(0)).buffer;
const toB64u = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

export async function createPasskey(options) {
  const publicKey = { ...options, challenge: toBuf(options.challenge), user: { ...options.user, id: toBuf(options.user.id) },
    excludeCredentials: (options.excludeCredentials || []).map((c) => ({ ...c, id: toBuf(c.id) })) };
  const c = await navigator.credentials.create({ publicKey });
  return { id: c.id, rawId: toB64u(c.rawId), type: c.type, authenticatorAttachment: c.authenticatorAttachment,
    clientExtensionResults: c.getClientExtensionResults?.() || {},
    response: { clientDataJSON: toB64u(c.response.clientDataJSON), attestationObject: toB64u(c.response.attestationObject),
      transports: c.response.getTransports?.() || [] } };
}

export async function getPasskey(options) {
  const publicKey = { ...options, challenge: toBuf(options.challenge),
    allowCredentials: (options.allowCredentials || []).map((c) => ({ ...c, id: toBuf(c.id) })) };
  const c = await navigator.credentials.get({ publicKey });
  return { id: c.id, rawId: toB64u(c.rawId), type: c.type, authenticatorAttachment: c.authenticatorAttachment,
    clientExtensionResults: c.getClientExtensionResults?.() || {},
    response: { clientDataJSON: toB64u(c.response.clientDataJSON), authenticatorData: toB64u(c.response.authenticatorData),
      signature: toB64u(c.response.signature), userHandle: c.response.userHandle ? toB64u(c.response.userHandle) : null } };
}

export const mfaErr = (e) => e?.response?.data?.detail?.message
  || (e?.name === "NotAllowedError" ? "The passkey prompt was cancelled or timed out." : "Something went wrong. Try again.");
